export enum PageLoadingStatus {
  Pending = "Pending",
  Loading = "Loading",
  Failed = "Failed",
  Success = "Success",
}
